import React, { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import AlertContext from '../../../../../Context/Alert/AlertContext'
import { BaseURL } from '../../../../../Files/BaseURL'
import SocketContext from '../../../../../Context/Socket/SocketContext';
import axios from 'axios';
import { formatDateForInput } from '../../../../../Files/UseFunction';
import { FaDownload, FaFileAlt, FaFileImage, FaFileVideo, FaRegFilePdf, FaTimes } from 'react-icons/fa';
import { BsFiletypeDocx } from 'react-icons/bs';
import { MdFolderZip } from 'react-icons/md';


const ServicePortfolio = () => {

    const [Profile, setProfile] = useState(null)
    const [Portfolio, setPortfolio] = useState(null)
    const [Conversation, setConversation] = useState([])
    const [TotalPages, setTotalPages] = useState(null)
    const [Page, setPage] = useState(null)
    const [message, setmessage] = useState('')
    const [ChatFile, setChatFile] = useState(null)
    const [FileName, setFileName] = useState(null)
    const [UploadedFile, setUploadedFile] = useState(null)

    const { userid, marketid } = useParams()
    const navigate = useNavigate()
    const location = useLocation()

    const alertcontext = useContext(AlertContext);
    const { showAlert } = alertcontext;

    const socketcontext = useContext(SocketContext);
    const { OnlineUsers, SocetConnection, isUserOnline } = socketcontext;

    const fetchconversation = async () => {
        try {
            const authToken = localStorage.getItem('p@token');
            const response = await axios.get(`${BaseURL}/api/messaging/getMessagesbyuser/${userid}`, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'auth-token': authToken,
                }
            });
            if (response.data.success) {
                setConversation(response.data.messages)
                setTotalPages(response.data.totalPages)
                setPage(response.data.page)
            } else {
                if (response.data.sameuser) {
                    setConversation(null)
                } else {
                    showAlert(response.data.message, 'danger')
                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        if (SocetConnection) {
            const handleMessage = (data) => {
                fetchconversation();
            };

            // Attach the event handler
            SocetConnection.on('message', handleMessage);

            // Cleanup function to remove the event handler
            return () => {
                SocetConnection.off('message', handleMessage);
            };
        }
    }, [SocetConnection, location.search]);


    const fetchPortfolio = async () => {
        try {
            const authToken = localStorage.getItem('p@token');
            const response = await fetch(`${BaseURL}/api/marektplace/Service/marketplacedetails/${userid}/${marketid}`, {
                headers: {
                    'auth-token': authToken,
                }
            });
            const data = await response.json();
            setProfile(data.User);
            setPortfolio(data.Portfolio)
        } catch (error) {
            showAlert('Error fetching Service Skills', 'danger');
        }
    };

    useEffect(() => {
        if (marketid) {
            fetchPortfolio()
            fetchconversation()
        }
    }, [marketid])

    const handleSendMessage = async (e) => {
        if (userid) {
            if (message !== "") {
                if (SocetConnection) {
                    await SocetConnection.emit('new message', {
                        UserID: userid,
                        covnersation: message,
                        File: {
                            Link: UploadedFile,
                            Name: FileName
                        }
                    })
                    setmessage("")
                    setUploadedFile(null)
                    setFileName(null)
                    setChatFile(null)
                }
            }
        }
    }

    const FileUpload = async (e) => {
        try {
            const file = e.target.files[0];
            setChatFile(file);
            setFileName(file.name);

            const formData = new FormData();
            formData.append('file', file);
            formData.append('filename', file.name);

            const authToken = localStorage.getItem('p@token');
            const response = await fetch(`${BaseURL}/api/messaging/upload-docs`, {
                method: "POST",
                headers: {
                    'auth-token': authToken,
                },
                body: formData
            });

            if (response.ok) {
                const data = await response.json();
                setUploadedFile(data?.location);
            } else {
                showAlert("File not uploaded, try again", 'danger');
            }
        } catch (error) {
            console.error("File upload error:", error);
            showAlert("File not uploaded, try again", 'danger');
        }
    };

    const renderFileIcon = (file) => {
        const fileType = file;
        switch (fileType) {
            case 'image':
                return <FaFileImage className='text-2xl w-full text-primarygreen' />;
            case 'video':
                return <FaFileVideo className='text-2xl w-full text-primarygreen' />;
            case 'pdf':
                return <FaRegFilePdf className='text-2xl w-full text-red-500' />;
            case 'application':
                return <FaRegFilePdf className='text-2xl w-full text-red-500' />;
            case 'doc':
                return <BsFiletypeDocx className='text-2xl w-full text-blue-500' />;
            case 'docx':
                return <BsFiletypeDocx className='text-2xl w-full text-blue-500' />;
            case 'zip':
                return <MdFolderZip className='text-2xl w-full text-gray-400' />;
            default:
                return <FaFileAlt className='text-2xl w-full text-primarygreen' />;
        }
    };

    return (
        <div className='w-[95%] m-auto py-6 flex flex-col gap-4'>
            <div className=" bg-white flex flex-col gap-6 rounded-2xl py-6 px-4">
                <div className="flex flex-col lg:flex-row justify-between gap-6 lg:gap-2">
                    <div className="flex flex-col md:flex-row font-pop items-center gap-2">
                        <div>
                            <img src={Profile?.ProfilePhoto} alt="" className='w-24 h-24 rounded-full' />
                        </div>
                        <div className="flex flex-col gap-1 md:gap-2">
                            <div className="flex flex-row gap-1 items-center">
                                <img src="../../Assets/Prop/badge.png" className='w-6 h-6' />
                                <h4 className='text-base text-lightGrey'>Level {Profile?.Level}</h4>
                            </div>
                            <h3 className='text-2xl font-semibold'>{Profile?.FirstName} {Profile?.LastName}</h3>
                            <h4 className='text-lg text-lightGrey'>@{Profile?.FirstName}{Profile?.LastName}</h4>
                        </div>
                    </div>
                    <div className="flex flex-col lg:text-right font-pop gap-2">
                        <h2 className='text-lightGrey font-medium'><span className='font-light'>Last seen: </span>5 hours ago</h2>
                        <h2 className='text-lightGrey font-medium'><span className='font-light'>Local time: </span>United Kingdom, 10 Mar 2024, 19:24</h2>
                    </div>
                </div>
            </div>

            <div className="bg-white py-4 px-6 rounded-2xl">
                <div className="flex flex-col lg:flex-row justify-between gap-4">
                    <div className="flex flex-col md:flex-row items-start gap-4">
                        <div className="md:w-[30%]">
                            <img src={Portfolio?.Images[0]?.img} alt="" className='h w-full object-cover rounded-2xl' />
                        </div>
                        <div className="flex flex-col justify-between h-full gap-2">
                            <div className="flex font-pop flex-col gap-1">
                                <p className='text-base text-lightGrey font-light'>Title:</p>
                                <h3 className='text-2xl font-medium'>{Portfolio?.Title}</h3>
                            </div>
                            <div className="flex font-pop flex-col gap-1">
                                <p className='text-base text-lightGrey font-light'>Description:</p>
                                <p className='text-base font-normal'>{Portfolio?.Pacakage?.Description}</p>
                            </div>
                            <div className="flex flex-row gap-8 items-center">
                                <div className="flex font-pop flex-col gap-1">
                                    <p className='text-base text-lightGrey font-light'>Delivery time:</p>
                                    <p className='text-base font-normal'>{Portfolio?.Pacakage?.Delivery}</p>
                                </div>
                                <div className="flex font-pop flex-col gap-1">
                                    <p className='text-base text-lightGrey font-light'>Number of concepts:</p>
                                    <p className='text-base font-normal'>{Portfolio?.Pacakage?.Concept}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col gap-4">
                        <div className="flex font-pop flex-col gap-2">
                            <p className='text-base text-lightGrey font-light'>Price:</p>
                            <h3 className='text-2xl font-medium'>${Portfolio?.Pacakage?.Price}</h3>
                        </div>
                        <button
                            className="bg-primarygreen text-center w-full border-2 border-primarygreen rounded-full font-pop text-white py-2 px-5 cursor-pointer"
                            onClick={() => { navigate(`/user-dashboard/service/purchase_service/${userid}/${marketid}`) }}
                        >
                            Purchase
                        </button>
                    </div>
                </div>
            </div>

            {Conversation !== null && <div className="bg-white rounded-2xl  py-6 px-6">
                <div className="flex flex-col gap-6 h-[100%] justify-between">
                    <div className="h-[60vh] overflow-y-scroll">
                        <div className="flex flex-col gap-2">
                            {Conversation?.length > 0 && Conversation?.map((item, index) => (
                                <div className={`${item.tag == "Sender" ? "flex flex-col justify-end" : " flex flex-col justify-start"} my-1 gap-1`}>
                                    {item?.File?.Link
                                        &&
                                        <div className={` p-2 rounded w-fit shadow-md font-pop flex items-end ${item.tag == "Sender" ? "bg-primarygreen/50 self-end text-white" : "bg-gray-300"}`}>
                                            <div className="flex flex-col gap-2">
                                                {item?.File && renderFileIcon(item?.File?.Link)}
                                                <span className="ml-2">{item?.File?.Name}</span>
                                            </div>
                                            <a href={item?.File?.Link} download={true} target='_blank'>
                                                <FaDownload
                                                    className="ml-2 text-3xl text-gray-500 cursor-pointer"
                                                />
                                            </a>
                                        </div>
                                    }
                                    <div className={`${item.tag == "Sender" ? "bg-primarygreen self-end text-white" : "bg-[#E8E8E8]"} rounded-xl py-2 px-3 max-w-xs w-fit`}>
                                        <p className='text-sm md:text-base'>{item?.message}</p>
                                    </div>
                                    <p className={`${item.tag == "Sender" ? "text-right" : "text-left"} text-xs`}>{formatDateForInput(item?.date)}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="flex flex-row font-pop justify-between items-center bg-[#E8E8E8] rounded-3xl py-2 px-4">
                        <div className="flex w-[100%] flex-row items-center gap-2">
                            <label htmlFor="fileupload" className='relative'>
                                <img
                                    src="../../../../../Assets/Prop/docattach.png"
                                    alt=""
                                    className='w-8 h-8'
                                />
                                <input
                                    type="file"
                                    id='fileupload'
                                    onChange={FileUpload}
                                    className='opacity-0 absolute'
                                />
                            </label>
                            <div className="flex gap-2 w-full">
                                {UploadedFile !== "" && UploadedFile !== null
                                    &&
                                    <div className="bg-gray-300 p-2 rounded shadow-md font-pop flex items-center">
                                        <div className="flex flex-col gap-2">
                                            {ChatFile && renderFileIcon(ChatFile)}
                                            <span className="ml-2 w-max text-xs">{FileName}</span>
                                        </div>
                                        <FaTimes
                                            className="ml-2 text-red-500 cursor-pointer"
                                            onClick={() => {
                                                setChatFile(null);
                                                setFileName(null);
                                                setUploadedFile(null);
                                            }}
                                        />
                                    </div>
                                }
                                <input
                                    type="text"
                                    value={message}
                                    onChange={(e) => { setmessage(e.target.value) }}
                                    placeholder='Message...'
                                    className='text-lg w-[100%] font-normal border-transparent outline-none focus:outline-none focus:border-transparent active:border-transparent active:outline-none bg-transparent'
                                />
                            </div>
                        </div>
                        <img
                            src="../../../../../../../Assets/Prop/messagesend.png"
                            alt=""
                            onClick={handleSendMessage}
                            className='w-8 h-8 cursor-pointer'
                        />
                    </div>
                </div>
            </div>}
        </div>
    )
}

export default ServicePortfolio